import * as React from 'react';
import { currency } from '~/lib/formatters';

const PaycodeConfirmation = (props) => {
  const { onClose, onEmail, onText, paycode, organization, displaySendCode, infoResult } = props;

  return (
    <div>
      <div className="blocks__cont">
        <div className="blocks__row__cont">
          <div className="blocks__row">
            <div className="blocks__box blocks__box--extra">
              <span className="blocks__lbl">Code</span>
              <span className="blocks__value blocks__value--code">
                {paycode.code}
              </span>
            </div>

            <div className="blocks__box blocks__box--extra">
              <span className="blocks__lbl">Amount issued</span>
              <span className="blocks__value blocks__value--amount">
                <span className="blocks__value__sign">$</span>
                {currency(paycode.amount)}
              </span>
            </div>

            <div className="blocks__box blocks__box--extra">
              <span className="blocks__lbl">Restriction</span>
              <span className="blocks__note">{organization && organization.name}</span>
            </div>

          </div>
          <div className="blocks__row">
            <div className="blocks__box blocks__box--notes">
              <span className="blocks__lbl">Notes</span>
              <span className="blocks__note--lg">{paycode.note}</span>
            </div>
          </div>
        </div>
      </div>

      {!displaySendCode &&
      <>
        <br />
        <div className="m__body__titl--lg" style={{ color: 'red' }}>{infoResult}</div>
        <div className="confirmation__send">
          <h3 className="confirmation__send__heading">Send Code to Driver:</h3>
          <div className="confirmation__send__buttons">
            <button
              onClick={onEmail}
              className="btn btn--prim btn--lg btn--white"
              type="button"
            >EMAIL
            </button>
            <button
              onClick={onText}
              className="btn btn--prim btn--lg btn--white"
              type="button"
            >TEXT
            </button>
          </div>
        </div>
        <br />
        <button
          className="btn btn--prim btn--full"
          type="button"
          onClick={onClose}
        >Close
        </button>
      </>
      }
    </div>
  );
};

export default PaycodeConfirmation;
